import { gql, useQuery } from '@apollo/client';

export const GET_TASK_TEMPLATES_BY_IDS = gql`
  query getTaskTemplatesByIds($taskTemplateIds: [String!]!) {
    getTaskTemplatesByIds(taskTemplateIds: $taskTemplateIds) {
      _id
      templateName
      taskNames
    }
  }
`;

export const useGetTaskTemplatesByIds = (ids: string[]) => {
  const { data, loading } = useQuery(GET_TASK_TEMPLATES_BY_IDS, {
    variables: { taskTemplateIds: ids },
    skip: !ids.length,
  });

  const taskTemplates = data?.getTaskTemplatesByIds || [];

  return { taskTemplates, loading };
};
